import type { GetAllPlansResponse } from '~/repository/modules/plan.module';
import { type AggregatedBundlePriceDto } from './ListingProduct.api.model';

export type Plan = {
  bundlePrices: AggregatedBundlePriceDto[];
  isFamilyAllowed: boolean;
  isFamilyPlan: boolean;
  parentPlanId: number | null;
  planId: number;
  planName: string;
  productId: number;
  productName: string;
};

export const mapAllPlansResponseToPlans = (
  response: GetAllPlansResponse,
): Plan[] => {
  const plans: Plan[] = [];
  const products = response.Data;

  if (!products || !Array.isArray(products)) {
    return plans;
  }

  for (const product of products) {
    const variant =
      product.Variants && product.Variants.length > 0
        ? product.Variants[0]
        : undefined;

    if (
      !variant ||
      !variant.Prices.BundlePrices ||
      variant.Prices.BundlePrices.length === 0
    ) {
      continue;
    }

    const firstBundlePrice = variant.Prices.BundlePrices[0];

    if (!firstBundlePrice.Plan) {
      continue;
    }

    plans.push({
      bundlePrices: variant.Prices.BundlePrices,
      isFamilyAllowed: firstBundlePrice.Plan.IsFamilyAllowed,
      isFamilyPlan: firstBundlePrice.Plan.IsFamilyPlan,
      parentPlanId: firstBundlePrice.Plan.ParentPlanId ?? null,
      planId: firstBundlePrice.Plan.PlanId,
      planName: firstBundlePrice.Plan.PlanName,
      productId: product.ProductId,
      productName: product.ProductName,
    });
  }

  return plans;
};
